import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const RequireAuth = ({ children }) => {
    let { user } = useContext(AuthContext);
    let location = useLocation();
    console.log("user",user);
     // Check if user is still loading (e.g., fetching from API)
  if (user === null) {
    return null; // Or you can display a loading indicator
  }
  
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default RequireAuth;